export default __webpack_public_path__ + "static/media/2021 utensils top.7bb16618.png";